import { render, staticRenderFns } from "./ListaAreaEmbargada.vue?vue&type=template&id=3644fdee&lang=pug"
import script from "./ListaAreaEmbargada.vue?vue&type=script&lang=js"
export * from "./ListaAreaEmbargada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports